@import '../../style/index';

@include host {
  @include reset-margin-top;

  display: inline-block;

  .icon-container {
    display: flex;
    justify-content: center;
  }
}
